
globalThis.PasswordToggler = (function() {
  function PasswordToggler($html) {
    this.$html = $html;
    this.$input = this.$html.find('*[data-target="password-toggler.input"]');
    this.$togglers = this.$html.find('*[data-target="password-toggler.toggler"]');

    this.init();
  }

  PasswordToggler.init = function($ctx) {
    ($ctx || $('body')).find('*[data-sb-controller="password-toggler"]').each(function() {
      new PasswordToggler($(this));
    });
  }

  PasswordToggler.prototype = {
    init: function() {
      this.events();
    },
    events: function() {
      var moduleInstance = this;

      moduleInstance.$togglers.on('click', function() {
        moduleInstance.$input.attr('type', moduleInstance.$input.attr('type') == 'password' ? 'text' : 'password')
        moduleInstance.$togglers.toggle();
      });
    }
  }

  return PasswordToggler;
})();
